import {Skeleton, Box} from "@mui/material";
import React from "react";

export const LoadingSkeleton = (
    {height, width, mr, ml, mb, mt}:
        {
            height: number | string,
            width: number | string,
            mr?: number,
            ml?: number,
            mt?: number
            mb?: number
        }
) => {

    return (
        <Box
            ml={ml}
            mr={mr}
            mb={mb}
            mt={mt}
        >
            <Skeleton
                height={height}
                width={width}
            />
        </Box>

    )
}